import { trpc } from '$src/lib/trpc'
import { createChatHooks } from '@markku/components'
import { sum } from '@markku/utils'
import {
  IconBook,
  IconCalendar,
  IconHome,
  IconMessage,
  IconUser,
} from '@tabler/icons-react'

export type NavigationTab =
  | 'home'
  | 'maintenance'
  | 'visits'
  | 'messages'
  | 'profile'

export interface NavigationItem {
  id: NavigationTab
  icon: React.ReactNode
  label: string
  route: string
  badge?: number
}

export function useUnreadMessageCount() {
  const chatHooks = createChatHooks(trpc)
  const { data: rooms } = chatHooks.useGetRooms()
  return sum(rooms?.map((r) => r.unreadCount) || [])
}

export function getNavigationItems(
  iconSize: number,
  unreadCount: number,
): NavigationItem[] {
  return [
    {
      id: 'home',
      icon: <IconHome size={iconSize} />,
      label: 'Koti',
      route: '/home',
    },
    {
      id: 'maintenance',
      icon: <IconBook size={iconSize} />,
      label: 'Huoltokirja',
      route: '/maintenance',
    },
    {
      id: 'visits',
      icon: <IconCalendar size={iconSize} />,
      label: 'Käynnit',
      route: '/visits',
    },
    {
      id: 'messages',
      icon: <IconMessage size={iconSize} />,
      label: 'Viestit',
      route: '/messages',
      badge: unreadCount,
    },
    {
      id: 'profile',
      icon: <IconUser size={iconSize} />,
      label: 'Profiili',
      route: '/profile',
    },
  ]
}
